<button (click)="exportZoningCodeToXLSX()" class="icon-button" [disabled]="isExporting" title="Export to Excel">
    <mat-icon class="icon">save_alt</mat-icon>
</button>
